import { Component } from '@angular/core';

@Component({
  selector: 'page-title,page-subtitle,page-sub-content,errors-block,app-layout-actions,order-widget-content',
  template: '<ng-content></ng-content>',
})
export class ContentComponent {}
